"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  InfoBar: true
};
exports.default = exports.InfoBar = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _isEnterOrSpace = require("../utils/isEnterOrSpace");
var _isFunction = require("../utils/isFunction");
var _Icon = require("../Icon/Icon");
var _InfoBar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./InfoBar.css") : void 0);
var _InfoBar2 = require("./InfoBar.types");
Object.keys(_InfoBar2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InfoBar2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InfoBar2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-info-bar';
/**
 * The **InfoBar** is a type of toolbar that appears above a list or table,
 *  and shows filter or selection settings:
 *
 * * Filter criteria: The **InfoBar** indicates the filter criteria that
 * have been applied for a filter or contextual filter.
 * Ideally, all applied filters should be conveyed in a **InfoBar**.
 * * Selected items: In a multi-select model,
 *  the **InfoBar** shows the number of items selected.
 *
 * Semantically, the information inside an **InfoBar** is rendered as a live-region "status".
 */
const InfoBar = exports.InfoBar = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      active,
      activeProps,
      info,
      className,
      onClick,
      iconName,
      iconProps,
      sticky
    } = props,
    otherProps = __rest(props, ["active", "activeProps", "info", "className", "onClick", "iconName", "iconProps", "sticky"]);
  const classnames = _bind.default.bind(_InfoBar.default);
  const isInteractive = (0, _isFunction.isFunction)(onClick);
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--active`]: active,
    [`${CSS_BLOCK}--interactive`]: active && isInteractive,
    [`${CSS_BLOCK}--sticky`]: sticky
  });
  const interactiveProps = active && isInteractive ? Object.assign(Object.assign({}, activeProps), {
    onClick,
    onKeyDown: event => {
      if ((0, _isEnterOrSpace.isEnterOrSpace)(event)) {
        event.preventDefault();
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
      }
    },
    role: 'button',
    tabIndex: 0
  }) : {};
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, interactiveProps, {
    ref: ref,
    className: classes
  }), info, iconName && /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, iconProps, {
    iconName: iconName
  })));
});
InfoBar.displayName = 'InfoBar';
var _default = exports.default = InfoBar;